import { render, staticRenderFns } from "./kategoriDenda.vue?vue&type=template&id=64ed29bc"
import script from "./kategoriDenda.vue?vue&type=script&lang=js"
export * from "./kategoriDenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports